/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantCreateDto } from '../../models/users-tenant-create-dto';
import { UsersTenantResponseDto } from '../../models/users-tenant-response-dto';

export interface TenantsControllerCreate$Params {
      body: UsersTenantCreateDto
}

export function tenantsControllerCreate(http: HttpClient, rootUrl: string, params: TenantsControllerCreate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersTenantResponseDto>;
    })
  );
}

tenantsControllerCreate.PATH = '/o2-users/tenants';
